import { css } from '@emotion/core'

const plain = ({ theme: { typography } }) => css``
export default plain
